import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { AuthGuard } from './authentication/guard/auth.guard';

const routes: Routes = [
  { path: '', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule), canLoad: [AuthGuard] },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    IonicModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
